<!-- Translated: no -->
<template>
  <Modal @close="localCloseModal" :wide="false" width="500px" :show-close="!isCreating">

    <!-- Last checks -->
    <div class="last-checks" v-if="!isCreating">
      <h2>Kontaktuppgifter</h2>

      <!-- <br /> -->

      <div v-if="!isAddonBooking">
        <p>Komplettera eller säkerställ att följande uppgifter stämmer.</p>
        <p><b>OBS!</b> Det är dessa uppgifter vi använder för att nå dig. Det är viktigt att informationen är korrekt.</p>
      </div>
      <div v-if="isAddonBooking">
        <p>Följande kontaktuppgifter är registrerade på din bokning, kontrollera att de stämmer.</p>
        <p style="margin-bottom: 0;">Om du behöver uppdatera uppgifterna kan du göra det direkt under <a href="#" @click="goToMyPages">Mina sidor</a> eller genom att kontakta gästservice på <a href="tel:054-13 26 00">054-13&nbsp;26&nbsp;00</a>.</p>
      </div>

      <br />

      <Loading :show="loading" :static="true" />

      <div v-if="!loading && !isAddonBooking">
        <LabelInput :required="true" label="Ditt telefonnummer" :value="phone" @change="updatePhone" />
        <span class="help">{{ $t('general.obs-format', {format: '+46701234567'}) }}</span>
        <div class="name-input">
          <LabelInput :required="true" label="Ditt förnamn" :value="name" @change="updateFirstName" />
          <LabelInput :required="true" label="Efternamn" :value="lastName" @change="updateLastName" />
        </div>

        <LabelInput :required="true" label="Din e-postadress" :value="email" @change="updateEmail" />

        <label class="label">Ditt land <span class="required">*</span></label>
        <CountrySwitcherNormal type="dropdown" :show-title="false" />

        <!-- <LabelInput :required="false" label="Eventuella noteringar till bokningen" :value="notes" @change="updateNotes" /> -->

        <div v-if="!smsSent && errors.length" class="error-message">
          <p v-for="error in errors" :key="error">{{ error }}</p>
        </div>
        
        <div v-if="enableQuickLogin" class="info-box--blue">
          <p>{{ enableQuickLogin }}</p>
          <p v-if="this.loggedIn">Notera att du kommer att bli utloggad från det konto du nu är inloggad på.</p>
        </div>

        <div v-if="errors2.length" class="error-message">
          <p v-for="error in errors2" :key="error">{{ error }}</p>
        </div>

        <div v-if="!smsSent">
          <button v-if="enableQuickLogin" @click="sendCodeSms" :disabled="!validated">Skicka SMS-kod</button>
          <p>&nbsp;</p>
          <button class="small white border" v-if="enableQuickLogin" @click="checkDetails" :disabled="!validated">Fortsätt</button>
        </div>

        <div v-if="smsSent">
          <LabelInput :required="true" label="Ange koden som du fått via SMS" :value="smsCode" @change="updateSmsCode" />
          <button @click="checkCode" :disabled="!validated">Verifiera</button>
        </div>

        <div v-if="!enableQuickLogin">
          <button @click="checkDetails" :disabled="!validated">Fortsätt</button>
        </div>
      </div>

      <div v-if="!loading && isAddonBooking" style="text-align:left;">
        <p style="margin-top: 0;"><b>Ditt telefonnummer:</b><br>{{ phone }}</p>
        
        <p><b>Ditt namn:</b><br>{{ name }} {{ lastName }}</p>

        <p><b>Din e-postadress:</b><br>{{ email }}</p>

        <p><b>Ditt land:</b><br>{{ country }}</p>

        <div style="margin-top: 20px;">
          <button @click="checkDetails" :disabled="!validated">Fortsätt</button>
          <span>&nbsp;</span>
          <button class="small white border" @click="localCloseModal">Gå tillbaka</button>
        </div>
      </div>
    </div>

    <CreatingOrder v-if="isCreating" :show-texts="true" :do-redirect="doRedirect" @callback="onSyncCallback" />

    <button style="margin-top: 50px;" class="small white border" @click="closeModal" v-if="isCreating">Avbryt</button>
  </Modal>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import API from '@/classes/API';
import Modal from '@/components/components/Modal';
import CreatingOrder from '@/components/parts/CreatingOrder';
import LabelInput from '@/components/components/LabelInput';
import Loading from '@/components/components/Loading';

import CountrySwitcherNormal from '@/components/components/CountrySwitcherNormal';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
    CreatingOrder,
    LabelInput,
    CountrySwitcherNormal,
    Loading,
  },
  mounted() {
    this.loading = true;

    const schools = this.$store.state.cart.skischools.filter(s => s.confirmed);
    const schoolNames = schools.map(s => s.name).filter(n => n);
    const schoolGuardians = schools.map(s => s.guardian).filter(n => n);
    const schoolPhones = schools.map(s => s.phone).filter(n => n);

    const rentals = this.$store.state.cart.rentals.filter(r => r.confirmed);
    const rentalNames = rentals.map(s => s.name).filter(n => n);
    const rentalPhones = rentals.map(s => s.phone).filter(n => n);

    if (schoolNames.length) {
      this.name = schoolNames[0];
    }
    if (schoolGuardians.length) {
      this.name = schoolGuardians[0];
    }
    if (rentalNames.length) {
      this.name = rentalNames[0];
    }

    if (schoolPhones.length) {
      this.phone = schoolPhones[0];
    }
    if (rentalPhones.length) {
      this.phone = rentalPhones[0];
    }

    // Check for lastname in firstname
    if (this.name) {
      const name = this.name;
      const index = name.indexOf(' ');  // Gets the first index where a space occours

      if (index > 0) {
        this.name = name.slice(0, index); // Gets the first part
        this.lastName = name.slice(index + 1);  // Gets the text part
      }
    }

    if (this.$store.state.cart.email) {
      this.email = this.$store.state.cart.email;
    }
    if (this.$store.state.cart.phone) {
      this.phone = this.$store.state.cart.phone;
    }
    if (this.$store.state.cart.name) {
      this.name = this.$store.state.cart.name;
    }
    // if (this.$store.state.cart.notes) {
    //   this.notes = this.$store.state.cart.notes;
    // }

    if (this.$store.state.cart.lastName) {
      this.lastName = this.$store.state.cart.lastName;
    }

    API.get('/account/user').then((response) => {
      const user = response.user;

      if (user && user.email) {
        user.name1 = user.name1 || '';
        user.name1 = user.name1.toLowerCase() === 'undefined' ? '' : user.name1;
        user.name1 = user.name1.toLowerCase() === 'null' ? '' : user.name1;
        user.name2 = user.name2 || '';
        user.name2 = user.name2.toLowerCase() === 'undefined' ? '' : user.name2;
        user.name2 = user.name2.toLowerCase() === 'null' ? '' : user.name2;

        this.email = user.email || this.email;
        this.phone = user.mobile_phone || this.phone;
        this.name = user.name1 || '';
        this.lastName = user.name2 || '';

        if (this.name.toLowerCase() === 'undefined') {
          this.name = '';
        }
        if (this.lastName.toLowerCase() === 'undefined') {
          this.lastName = '';
        }

        if (user.addr5) {
          this.country = user.addr5;

          if (this.country === 'SE') {
            this.country = 'Sverige';
          }
        }
      }

      this.loading = false;
    });

    // if (this.$store.state.isOnSite) {
    //   this.moveOn();
    //   return;
    // }

    // if (window.bookingIsLoggedIn()) {
    //   this.moveOn();
    //   return;
    // }

    // if (!this.$store.state.cart.pincode) {
    //   this.moveOn();
    // }
  },
  data() {
    return {
      isCreating: false,
      phone: '',
      email: '',
      name: '',
      lastName: '',
      country: '',
      // notes: '',
      loading: false,
      errors: [],
      errors2: [],
      enableQuickLogin: '',
      smsSent: false,
      smsCode: '',
      checkingSomething: false,
    };
  },
  computed: {
    ...mapGetters([
      'loggedIn',
    ]),
    doRedirect() {
      if (this.$store.state.isOnSite) {
        return false;
      }
      return true;
    },
    validated() {
      if (this.isAddonBooking) {
        return true;
      }

      if (!this.phone) {
        return false;
      }
      if (!this.email) {
        return false;
      }
      if (!this.name) {
        return false;
      }
      if (!this.lastName) {
        return false;
      }

      if (this.phone.toString().replaceAll(' ', '').replaceAll('-', '').match(/^\+[0-9]{9,13}$/) === null) {
        return false;
      }

      if (this.email.toString().match(/(.+)@(.+){2,}\.(.+){2,}/) === null) {
        return false;
      }

      if (!localStorage.getItem('country')) {
        return false;
      }

      if (this.checkingSomething) {
        return false;
      }

      return true;
    },
    isAddonBooking() {
      return this.$store.state.cart.addToOrder && this.$store.state.cart.addToOrder.numeric;
    },
  },
  methods: {
    ...mapMutations([
      'closeModal',
      'openModal',
      'updateUserDetails',
      'setUser',
    ]),
    resetStatus() {
      this.errors = [];
      this.errors2 = [];
      this.smsSent = false;
      this.smsCode = '';
      this.checkingSomething = false;
      this.enableQuickLogin = '';
    },
    updatePhone(e) {
      this.phone = e;
      this.resetStatus();
    },
    updateEmail(e) {
      this.email = e;
      this.resetStatus();
    },
    updateFirstName(e) {
      this.name = e;
    },
    updateLastName(e) {
      this.lastName = e;
    },
    // updateNotes(e) {
    //   this.notes = e;
    // },
    updateSmsCode(e) {
      this.smsCode = e;
    },
    localCloseModal() {
      if (!this.isCreating) {
        this.closeModal();
      }
    },
    onSyncCallback(number) {
      if (this.$store.state.isOnSite) {
        this.openModal(['OnSitePayment', {
          confirmationOnly: true,
          orderNumber: number,
        }]);
      }
    },
    /*eslint-disable */
    async checkDetails() {
      this.updateUserDetails({
        email: this.email,
        phone: this.phone,
        name: this.name,
        lastName: this.lastName,
        // notes: this.notes,
      });

      this.checkingSomething = true;

      const { success, errors } = await API.frontendHelper('verify-user-details', this.$store.state);

      this.checkingSomething = false;
      this.errors = [];

      if (!success) {
        let errorLength = Object.keys(errors).length;

        for (let i in errors) {
          if (errors.hasOwnProperty(i)) {
            if (i !== 'user.exists') {
              this.errors.push(errors[i].message);
            } else {
              console.log('user error');
              if (errorLength === 1) {
                this.enableQuickLogin = errors[i].message;
              }
            }
          }
        }
      } else {
        this.isCreating = true;
      }
    },
    async sendCodeSms() {
      this.checkingSomething = true;
      const { success, msg } = await API.post(`account/send-verification-code`, { email: this.email, phone: this.phone });
      this.checkingSomething = false;

      this.errors2 = [];

      if (success) {
        this.smsSent = true;
      } else {
        this.errors2.push(msg);
      }
    },
    async checkCode() {
      this.checkingSomething = true;
      const { success, user, isAdmin, token } = await API.post(`account/authenticate-verification-code`, { verificationCode: this.smsCode, email: this.email, phone: this.phone });
      this.checkingSomething = false;

      this.errors2 = [];

      if (success) {
        this.$store.state.user = user;
        this.$store.state.user.isAdmin = isAdmin;
        this.$store.state.user.token = token;

        this.setUser({
          token,
        });

        this.$emit('login', success);

        document.body.dispatchEvent(new CustomEvent('bookinguserstatechanged', { detail: true }));

        this.resetStatus();

        this.checkDetails();
      } else {
        this.errors2.push('Koden stämmer inte');
      }
    },
    goToMyPages(e) {
      e.stopPropagation();
      e.preventDefault();
      this.closeModal();
      this.$router.push('/mina-sidor/uppgifter');
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'
.info-box--blue
  info-box()
  info-box--blue()
  margin-bottom: 1em

.help
  text-align left
  font-size 90%
  display block
  margin-top -10px
  margin-bottom 15px

h2
  font-size: 20px;
  font-weight: 900;
  text-align: center;
  color: #262626;
  united-heavy()
  uppercase()

hr
  height 1px
  background-color light-blue-grey
  margin-top 20px
  margin-bottom 20px

.modalo
  text-align center

.info
  border-radius 2px
  background-color rgba(199, 220, 183, 0.26)
  border solid 1px #d1e0c2
  padding 15px 27px
  margin-top: 30px
  text-align: left

  b
    font-size 11px
    font-weight bold
    color #1c1c1c
    display block
    margin-bottom 0.9em
    uppercase()
    .icon
      margin-right 3px
      position relative
      top -1px
  p
    font-size 14px
    font-weight 300
    line-height 1.3
    color #262626
    margin 0
  &.small
    padding 10px 8px
    p
      font-size 11px
      color #1c1c1c

.status
  font-size 30px
  margin-top space-3
  animation: pulsingimage 1.5s infinite;

.bar
  background-color light-blue-grey
  height 12px
  margin-top space-3
  .inner
    background-color greenish
    height 12px
    transition all 0.5s

.last-checks
  text-align: left

.label
  text-transform: uppercase;
  font-size: 11px;
  font-weight: bold;
  text-align: left;
</style>

<style lang="stylus">
.name-input
  display: flex;
  justify-content: space-between;
  div
    width 48%
    input
      min-width 10px
</style>

<style scoped>
@keyframes pulsingtext {
  0%   {transform: scale(0.95); }
  50% { transform: scale(1.05); }
  100% { transform: scale(0.95); }
}
</style>



// WEBPACK FOOTER //
// CreatingOrder.vue?4a2e9dee